export default {
  RESET_PWD_DONE (state, done) {
    state.resetPwdDone = done
  },
  SET_DATA_RETENTION (state, time) {
    state.dataRetention = time
  },
  SET_TOKEN (state, token) {
    state.token = token
  },
  SET_USER (state, user) {
    state.user = user
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js